module.exports = __webpack_public_path__ + "static/media/01_CALCINHA_LATERAL_DRAPEADA_LISA_02.24444e5a.jpg";